import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { Icon } from "@vds/icons"; // Replace with your exact VDS Icon import path
import DisplayCanvas from "../../../polygonLib/displayPolygonLib/displayCanvas";
import { transformPolygonData } from "../../utility/roiUtils";
import { DELETE_ROI, ROI_MESSAGES } from "../../constants/roiConstants";
import { DELETE_GROUP_MODAL_CONSTANTS } from "../../constants/constants";

const RoiActionModal = ({
  isOpen,
  onClose,
  onDelete,
  selectedRoi,
  appName,
  imageSize = { width: 214, height: 128 },
  snapshot="",
  modalType,
  title,
  confirmButtonText,
  cancelButtontext,
  bodyMessage,
  bodyMessageContinue
}) => {
  const modalOriginalSize = selectedRoi?.customdata?.polygon?.polygon?.frame
    ? [selectedRoi.customdata, selectedRoi.customdata]
    : "";

  return (
    <Modal
      opened={isOpen}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      surface="light"
      fullScreenDialog={false}
      disableAnimation={false}
      disableOutsideClick={true}
      closeButton={
        <div className="modal-close-button"
          data-testid="roiList_modalCloseIcon"
          onClick={onClose}
        >
          <Icon name="close" />
        </div>
      }
    >
      <ModalTitle>{title}</ModalTitle>
      <ModalBody>
        {snapshot && (
          <div
            style={{
              paddingBottom: "15px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <DisplayCanvas
              imageSize={imageSize}
              initialPolygons={transformPolygonData(selectedRoi?.customdata)}
              originalSize={modalOriginalSize}
              videoSource={snapshot}
            />
          </div>
        )}
        {bodyMessage}{" "}
        {appName} {bodyMessageContinue}
      </ModalBody>
      <ModalFooter
        buttonData={{
          primary: {
            width: "100%",
            children: DELETE_GROUP_MODAL_CONSTANTS.CANCEL_BUTTON,
            "data-testid": "roiList_noCancelButton",
            onClick: onClose,
          },
          close: {
            width: "100%",
            children: confirmButtonText ,
            "data-testid": "roiList_yesDeleteButton",
            onClick: onDelete,
          },
        }}
      />
    </Modal>
  );
};

export default RoiActionModal;